import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { RootState } from '../../store';
import {
    LoadAllLocationsForAccountingArea,
    LocationOverviewDto,
} from '../../store/locationsSlice';
import { LoadMansions, Mansion } from '../../store/mansionsSlice';
import useTranslate from '../useTranslate';
import { isFinal, RequestStatus } from '../../store/network/managedRequest';
import { PbRequest } from '../../store/pbRequest';

interface Props {
    requestStatus: RequestStatus;
    allLocations?: LocationOverviewDto[];
    mansionsById: { [id: string]: Mansion };

    LoadAllLocationsForAccountingArea: () => void;
    LoadMansions: () => void;
}

function VipSelectLocationCard(props: Readonly<Props>) {
    useEffect(() => {
        props.LoadMansions();
        props.LoadAllLocationsForAccountingArea();
    }, []);

    const strings = useTranslate('VipSelectLocationCard');

    const allLocations = props.allLocations || [];

    if (!isFinal(props.requestStatus)) {
        return <div>{strings.loading}</div>;
    }

    if (allLocations.length === 0) {
        return <div>{strings.empty}</div>;
    }

    return (
        <table className={'data-table'} style={{ width: '100%' }}>
            <thead>
                <tr>
                    <th>{strings.locationName}</th>
                    <th>{strings.locationAddress}</th>
                    <th />
                </tr>
            </thead>
            <tbody>{allLocations.map(renderLocation)}</tbody>
        </table>
    );

    function renderLocation(location: LocationOverviewDto) {
        const mansion: Mansion | undefined =
            props.mansionsById[location.mansion_id];
        return (
            <tr>
                <td>{location.name}</td>
                <td>
                    {mansion &&
                        `${mansion.address.street} ${mansion.address.housenumber}`}
                    <br />
                    {mansion &&
                        `${mansion.address.postalcode} ${mansion.address.city}`}
                </td>
                <td>
                    <Link
                        to={`/objects/${location.mansion_id}/${location.id}/vip-user-pricing`}
                        className="icon icon-wew-button-enter icon-sm"
                    />
                </td>
            </tr>
        );
    }
}

export default connect(
    (state: RootState) => ({
        allLocations: state.locations.allLocationsForAccountingArea,
        requestStatus:
            state.pbRequest[PbRequest.GET_ALL_LOCATIONS_FOR_ACCOUNTING_AREA]
                .status,
        mansionsById: state.mansions.mansionsById,
    }),
    { LoadAllLocationsForAccountingArea, LoadMansions }
)(VipSelectLocationCard);
